var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '#query-hooks';
import { GUEST_LINK_PATH_RESOLUTION_STALE_TIME } from '../../constants/guest-links';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
import { loadFsEntryPath } from './fsEntryPathLoader';
export const guestLinkFsEntryGetPathQueryOptions = ({ emailVerified, filespaceId, fsEntryId, linkId, plugFilespaceClient, workspaceId, }) => ({
    queryKey: GuestLinkKeyFactory.entryPath({
        workspaceId,
        filespaceId,
        linkId,
        fsEntryId,
    }),
    queryFn: async () => {
        return loadFsEntryPath({
            filespaceId,
            fsEntryId,
            plugFilespaceClient,
            workspaceId,
        });
    },
    enabled: Boolean(emailVerified && fsEntryId.length),
    networkMode: 'always',
    staleTime: GUEST_LINK_PATH_RESOLUTION_STALE_TIME,
    retry: 0,
});
export const useGuestLinkFsEntryGetPath = ({ filespaceId, fsEntryId, linkId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery(guestLinkFsEntryGetPathQueryOptions({
        fsEntryId,
        workspaceId,
        filespaceId,
        linkId,
        emailVerified: currentUser?.emailVerified,
        plugFilespaceClient,
    }));
    return query;
};
_react_refresh_temp_1(useGuestLinkFsEntryGetPath, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
